import { HighLevelStatus } from '@/src/listings/utils/highLevelStatus';
import { defineMessage, type MessageDescriptor } from 'react-intl';

export const CONVERSION_BAR_MESSAGES: Partial<Record<HighLevelStatus, MessageDescriptor>> = {
  [HighLevelStatus.EVENT_ENDED]: defineMessage({
    id: 'Sales ended',
    defaultMessage: 'Sales ended',
    description: 'Sales ended message for ended/completed events in conversion bar',
  }),
  [HighLevelStatus.SALES_ENDED]: defineMessage({
    id: 'Sales ended',
    defaultMessage: 'Sales ended',
    description: 'Sales ended event message in conversion bar',
  }),
  [HighLevelStatus.SOLD_OUT]: defineMessage({
    id: 'Sold out',
    defaultMessage: 'Sold out',
    description: 'Event status indicating tickets are sold out',
  }),
  [HighLevelStatus.UNAVAILABLE]: defineMessage({
    id: 'Unavailable',
    defaultMessage: 'Unavailable',
    description: 'Unavailable event message in conversion bar',
  }),
  [HighLevelStatus.POSTPONED]: defineMessage({
    id: 'Postponed',
    defaultMessage: 'Postponed',
    description: 'Event status indicating the event has been postponed',
  }),
  [HighLevelStatus.CANCELLED]: defineMessage({
    id: 'Cancelled',
    defaultMessage: 'Cancelled',
    description: 'Event status indicating the event has been cancelled',
  }),
  [HighLevelStatus.SALES_START_SOON]: defineMessage({
    id: 'On sale {date}',
    defaultMessage: 'On sale {date}',
    description: 'Sales start soon event message in conversion bar',
  }),
};

// Check this list as it was generated with an AI tool from CORE codebase
export const SUPPORTED_CURRENCIES = [
  'USD',
  'CAD',
  'EUR',
  'GBP',
  'JPY',
  'AUD',
  'NZD',
  'CHF',
  'HKD',
  'SGD',
  'SEK',
  'DKK',
  'PLN',
  'NOK',
  'HUF',
  'CZK',
  'MXN',
  'ILS',
  'ARS',
  'BRL',
  'CLP',
  'MYR',
  'PHP',
  'TWD',
  'THB',
  'TRY',
];
